import {
  type AttributeDataTypeType,
  FormSchemaQuestionType,
  type FormSchemaType,
} from "@validereinc/domain";
import type { WatchedFields } from "@validereinc/domain-controllers";
import type { RecordValueType } from "@validereinc/utilities";
import React from "react";
import { MeasurementField } from "./MeasurementField";
import { QuestionField } from "./QuestionField";

export const FormSubmissionField = (
  props: {
    dataKey: string;
    name: string;
    isReady?: boolean;
    isValid?: boolean;
    isBusy?: boolean;
    isDisabled?: boolean;
    data_type?: AttributeDataTypeType;
  } & FormSchemaQuestionType &
    Partial<RecordValueType<WatchedFields>["calculation"]> &
    Partial<{
      questionsMap: FormSchemaType["config"]["questions"];
    }> &
    Partial<{
      measurement_type: string;
      measurement_unit: string;
    }>
) => {
  const { type, dataKey, ...questionProps } = props;

  return (
    <>
      {type === FormSchemaQuestionType.QUESTION && questionProps.data_type ? (
        <div style={{ width: 400 }}>
          <QuestionField
            key={dataKey}
            {...questionProps}
            data_type={questionProps.data_type}
          />
        </div>
      ) : null}
      {type === FormSchemaQuestionType.MEASUREMENT &&
      questionProps.measurement_unit &&
      questionProps.measurement_type ? (
        <MeasurementField
          key={dataKey}
          {...questionProps}
          measurement_type={questionProps.measurement_type}
          measurement_unit={questionProps.measurement_unit}
          sourceFields={questionProps.sourceFields ?? []}
          sourceFieldValues={questionProps.sourceFieldValues ?? {}}
          questionsMap={questionProps.questionsMap ?? {}}
        />
      ) : null}
    </>
  );
};
